module.exports = __webpack_public_path__ + "img/RX-Arcos-8-zoom.57c20dd9.png";